import React from 'react';

const BTN_TEXT = {
  pharmacist: '€ 195 – PHARMACIST EXAM PREP PURCHASE'
};

export const SubscribeButton = ({topic, onClick, title}) => {
  const handleClick = () => {
    onClick(topic);
  };

  return (
    <div>
      {/* <p>{`${(topic.tutorial_type || '').toUpperCase()} OPTION`}</p> */}
      <button className="btn-new-main" onClick={handleClick}>{title || BTN_TEXT[topic.tutorial_type]}</button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/profile/components/SubscribeButton.js